import {collection, limit, onSnapshot, query, where} from 'firebase/firestore'
import {useEffect, useState} from 'react'
import {db} from '../fetchers/firebase'
import {sessionStore} from '../stores/session/sessionStore'
import {DB_SIMULATIONS, DB_USERS} from './consts'

const useCurrentSimulation = () => {
  const user = sessionStore(state => state.user)
  const [loading, setLoading] = useState<boolean>(true)
  const currentSimulation = sessionStore(state => state.currentSimulation)
  const setCurrentSimulation = sessionStore(state => state.setCurrentSimulation)

  useEffect(() => {
    if (!user) return
    setLoading(true)
    return onSnapshot(
      query(
        collection(db, `${DB_USERS}/${user!.id}/${DB_SIMULATIONS}`),
        where('current', '==', true),
        limit(1)
      ),
      querySnapshot => {
        setCurrentSimulation(
          !querySnapshot.empty
            ? {
                id: querySnapshot.docs[0].id,
                ...querySnapshot.docs[0].data(),
              }
            : null
        )
        setLoading(false)
      }
    )
  }, [user])

  return {currentSimulation, loading}
}

export default useCurrentSimulation
